/* SAPONE PDP (sections/sapone-16-pdp.liquid). 2026-10-08 speed: moved here verbatim from the section's inline
   <script data-sapone="pdp"> (it has no Liquid), loaded with defer. Only addition: the gallery poster loader. */
(function(){
  var F = {
    moisture:{name:"Moisture",made:"dry, thirsty hair",ph:"5.0 – 5.2",actives:[["glycerin","a humectant, which means it holds water. the most used moisturising ingredient in cosmetics."],["provitamin B5","gets inside the hair, not just onto it."],["arginine","an amino acid. hair is made of them."]],inci:"Aqua, Glycerin, Sodium Cocoyl Glutamate, Sodium Cocoyl Isethionate, Cocamidopropyl Betaine, Betaine, Panthenol, Coco-Glucoside, Sclerotium Gum, Sodium Benzoate, Guar Hydroxypropyltrimonium Chloride, Arginine, Potassium Sorbate, Coco-Caprylate/Caprate, Citric Acid, Phytic Acid"},
    repair:{name:"Repair",made:"damaged, over-processed hair",ph:"4.8 – 5.0",actives:[["hydrolysed keratin","keratin, hydrolysed into fragments. hair is keratin."],["gluconamide",""],["provitamin B5","gets inside the hair, not just onto it."],["arginine","an amino acid"]],inci:"Aqua, Sodium Cocoyl Glutamate, Sodium Cocoyl Isethionate, Cocamidopropyl Betaine, Glycerin, Panthenol, Coco-Glucoside, Hydrolyzed Keratin, Hydroxypropyl Gluconamide, Hydroxypropylammonium Gluconate, Sclerotium Gum, Sodium Benzoate, Arginine, Guar Hydroxypropyltrimonium Chloride, Potassium Sorbate, Citric Acid, Malic Acid, Phytic Acid"},
    volume:{name:"Volume",made:"fine, flat hair",ph:"5.0 – 5.2",actives:[["rice protein","a hydrolysed plant protein"],["bamboo extract",""],["zinc PCA","the zinc salt of PCA"]],inci:"Aqua, Sodium Cocoyl Glutamate, Sodium Cocoyl Isethionate, Cocamidopropyl Betaine, Glycerin, Panthenol, Coco-Glucoside, Hydrolyzed Rice Protein, Sclerotium Gum, Polyquaternium-11, Sodium Benzoate, Potassium Sorbate, Citric Acid, Zinc PCA, Bambusa Vulgaris Extract, Guar Hydroxypropyltrimonium Chloride, Phytic Acid"},
    curls:{name:"Curls",made:"curls and coils",ph:"5.0 – 5.2",actives:[["flaxseed",""],["quinoa protein","a hydrolysed plant protein"],["guar","guar gum, made cationic. hair's surface is negatively charged."],["glycerin","a humectant, which means it holds water. the most used moisturising ingredient in cosmetics."]],inci:"Aqua, Sodium Cocoyl Glutamate, Sodium Cocoyl Isethionate, Cocamidopropyl Betaine, Glycerin, Panthenol, Coco-Glucoside, Guar Hydroxypropyltrimonium Chloride, Sclerotium Gum, Sodium Benzoate, Hydrolyzed Quinoa, Coco-Caprylate/Caprate, Potassium Sorbate, Citric Acid, Linum Usitatissimum Seed Extract, Phytic Acid"},
    scalp:{name:"Scalp",made:"greasy roots",ph:"4.8 – 5.1",actives:[["salicylic acid","a beta hydroxy acid"],["zinc PCA","the zinc salt of PCA"],["kaolin","a clay"],["peppermint",""]],inci:"Aqua, Sodium Cocoyl Glutamate, Sodium Cocoyl Isethionate, Cocamidopropyl Betaine, Glycerin, Coco-Glucoside, Panthenol, Salicylic Acid, Kaolin, Sclerotium Gum, Sodium Benzoate, Potassium Sorbate, Zinc PCA, Guar Hydroxypropyltrimonium Chloride, Citric Acid, Camellia Sinensis Leaf Extract, Mentha Piperita Oil, Phytic Acid"},
    flakes:{name:"Flakes",made:"a flaking, dry scalp",ph:"4.8 – 5.1",actives:[["piroctone olamine",""],["tea tree","an essential oil"],["niacinamide","vitamin B3"]],inci:"Aqua, Sodium Cocoyl Glutamate, Sodium Cocoyl Isethionate, Cocamidopropyl Betaine, Glycerin, Coco-Glucoside, Panthenol, Piroctone Olamine, Sclerotium Gum, Sodium Benzoate, Melaleuca Alternifolia Leaf Oil, Niacinamide, Guar Hydroxypropyltrimonium Chloride, Potassium Sorbate, Citric Acid, Salix Alba Bark Extract, Allantoin, Phytic Acid"}
  };
  var SHELL = ["Sodium Cocoyl Isethionate","Stearic Acid","Tapioca Starch","Cetearyl Alcohol","Aqua","Butyrospermum Parkii (Shea) Butter","Stearyl Alcohol","Kaolin","Sodium Isethionate","Glycerin","Sodium Lactate","Parfum","Lactic Acid","Tocopherol","Sodium Phytate"];
  var SCENT = {vanilla:"vanilla milk",unscented:"unscented"};
  var V = {
    moisture:{vanilla:"58811279999308",unscented:"58811280195916"},
    repair:{vanilla:"58811280097612",unscented:"58811280294220"},
    volume:{vanilla:"58811280064844",unscented:"58811280261452"},
    curls:{vanilla:"58811280032076",unscented:"58811280228684"},
    scalp:{vanilla:"58811280130380",unscented:"58811280326988"},
    flakes:{vanilla:"58811280163148",unscented:"58811280359756"}
  };
  var SVGNS = "http://www.w3.org/2000/svg";

  function phSvg(svg, ph){
    var nums = (ph.match(/\d[.,]\d/g)||[]).map(function(n){return parseFloat(n.replace(",","."));});
    if (nums.length < 2) return;
    var lo = nums[0], hi = nums[1];
    var x = function(v){ return 20 + (v - 4) * 80; };
    var cxL = x((lo + hi) / 2), cxR = x(7);
    var rose = "#C2848A", muted = "#7B4B56", plum = "#5C1A1B";
    var h = '';
    h += '<text x="'+cxL+'" y="16" text-anchor="middle" font-size="9" letter-spacing="1" fill="'+plum+'">SMOOTH · this one</text>';
    h += '<text x="'+cxR+'" y="16" text-anchor="middle" font-size="9" letter-spacing="1" fill="'+muted+'">ROUGH · most shampoos</text>';
    h += '<line x1="'+cxL+'" y1="85" x2="'+cxL+'" y2="141" stroke="'+plum+'" stroke-width="1.5"/>';
    h += '<line x1="'+cxR+'" y1="85" x2="'+cxR+'" y2="148" stroke="'+muted+'" stroke-width="1" stroke-dasharray="3 3"/>';
    h += '<circle cx="'+cxL+'" cy="58" r="27" fill="#f5f0e8" stroke="'+plum+'" stroke-width="2"/>';
    h += '<rect x="'+(cxL-22)+'" y="52" width="44" height="13" rx="6.5" fill="#EDE6D8" stroke="'+plum+'" stroke-width="1"/>';
    [-18,-9,0,9].forEach(function(o){ h += '<line x1="'+(cxL+o)+'" y1="53.5" x2="'+(cxL+o+8)+'" y2="56.5" stroke="'+plum+'" stroke-width="1"/>'; });
    h += '<circle cx="'+cxR+'" cy="58" r="27" fill="#f5f0e8" stroke="'+muted+'" stroke-width="1.5"/>';
    h += '<rect x="'+(cxR-22)+'" y="54" width="44" height="13" rx="6.5" fill="#EDE6D8" stroke="'+muted+'" stroke-width="1"/>';
    [-19,-9,1,11].forEach(function(o){ h += '<path d="M '+(cxR+o)+' 55 l 4 -8 l 4 8" fill="none" stroke="'+muted+'" stroke-width="1"/>'; });
    h += '<rect x="'+x(4)+'" y="142" width="'+(x(5.5)-x(4))+'" height="12" rx="6" fill="'+rose+'" opacity="0.28"/>';
    h += '<line x1="'+x(4)+'" y1="148" x2="'+x(8)+'" y2="148" stroke="'+muted+'" stroke-width="1" opacity="0.4"/>';
    [4,5,6,7,8].forEach(function(v){
      h += '<line x1="'+x(v)+'" y1="144" x2="'+x(v)+'" y2="152" stroke="'+muted+'" stroke-width="1" opacity="0.6"/>';
      h += '<text x="'+x(v)+'" y="168" text-anchor="middle" font-size="11" fill="'+muted+'">'+v+'</text>';
    });
    h += '<line x1="'+x(5.5)+'" y1="96" x2="'+x(5.5)+'" y2="154" stroke="'+rose+'" stroke-width="1" stroke-dasharray="3 3"/>';
    h += '<text x="'+(x(5.5)+5)+'" y="104" font-size="10" fill="'+rose+'">5.5</text>';
    h += '<rect x="'+x(lo)+'" y="141" width="'+Math.max(x(hi)-x(lo),14)+'" height="14" rx="7" fill="'+plum+'"/>';
    h += '<text x="'+((x(lo)+x(hi))/2)+'" y="186" text-anchor="middle" font-size="11" fill="'+plum+'">this one '+ph.replace(/\s*–\s*/," to ")+'</text>';
    svg.innerHTML = h;
  }

  function gallery(root){
    if (root.dataset.on) return; root.dataset.on = '1';
    var rail = root.querySelector('[data-gal-rail]');
    var n = rail.children.length;
    var iEl = root.querySelector('[data-gal-i]');
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-gal-to]'));
    var vids = [].slice.call(root.querySelectorAll('[data-gal-video]'));
    var i = 0, pending = null;
    /* 2026-10-08 speed: the clips' posters wait in data-gal-poster (see the section). poster() moves one into place;
       paint() calls it for a clip whose slide is the current one or next to it, and allPosters() fills both
       after window load once the browser is idle, so nothing is fetched before load but a poster is there
       before anyone can swipe to it. */
    function poster(v){ var p = v.getAttribute('data-gal-poster'); if (p && !v.getAttribute('poster')) v.setAttribute('poster', p); }
    /* v54: slides 2+ wait in data-gsrc/data-gsrcset (see the section) */
    var shotsOn = false;
    function shots(){
      if (shotsOn) return; shotsOn = true;
      [].forEach.call(rail.querySelectorAll('img[data-gsrc]'), function(im){
        var ss = im.getAttribute('data-gsrcset'); if (ss) im.setAttribute('srcset', ss);
        im.setAttribute('src', im.getAttribute('data-gsrc')); im.removeAttribute('data-gsrc'); im.removeAttribute('data-gsrcset');
      });
    }
    function allPosters(){ vids.forEach(poster); }
    function paint(k){
      i = k; iEl.textContent = i + 1;
      [].forEach.call(root.querySelectorAll('[data-gal-dots] i'), function(d, j){ d.classList.toggle('on', j === i); });
      prev.disabled = i === 0; next.disabled = i === n - 1;
      thumbs.forEach(function(t, j){ t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (k > 0) shots();
      var near = [i-1, i, i+1];
      [].slice.call(rail.children).forEach(function(s, j){
        var v = s.querySelector('video'); if (!v) return;
        if (near.indexOf(j) > -1) poster(v);
        if (near.indexOf(j) > -1 && v.preload !== 'auto'){ v.preload = 'auto'; v.load(); }
        if (j === i){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      });
    }
    function go(k){
      k = Math.max(0, Math.min(n - 1, k));
      pending = k; paint(k);
      rail.scrollTo({left: k * rail.clientWidth, behavior: 'smooth'});
    }
    rail.addEventListener('scroll', function(){
      if (!rail.clientWidth) return;
      var k = Math.round(rail.scrollLeft / rail.clientWidth);
      if (pending !== null){ if (k !== pending) return; pending = null; }
      if (k !== i) paint(k);
    }, {passive:true});
    rail.addEventListener('pointerdown', function(){ pending = null; });
    prev.addEventListener('click', function(){ go(i - 1); });
    next.addEventListener('click', function(){ go(i + 1); });
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.getAttribute('data-gal-to'), 10)); }); });
    paint(0);
    (function(){
      /* v51 speed: posters of the far clips wait for the shopper's first touch/scroll/key (PageSpeed counted them as
         page-load bytes when they came at load+idle); paint() still sets them for any slide near the current one. */
      var evs = ['pointerdown', 'touchstart', 'scroll', 'keydown', 'wheel'];
      function first(){ evs.forEach(function(e){ window.removeEventListener(e, first, true); }); allPosters(); shots(); }
      function later(){ requestIdleCallback(function(){ setTimeout(shots, 1500); }, {timeout:2000}); }
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
      evs.forEach(function(e){ window.addEventListener(e, first, {capture:true, passive:true}); });
    })();

    /* AUTO PEEK. Not a carousel autoplay: it runs one short sequence once the gallery is
       actually on screen, advances at most twice, then stops for good. Any pointer, touch,
       wheel, key or focus kills it permanently (ARIA APG: rotation does not resume). It is
       skipped entirely under prefers-reduced-motion, on a hidden tab, and when there are
       fewer than three frames. It drives the existing go() so the counter, arrows and
       thumbnails stay in sync, and it never touches transform, so native swipe is intact. */
    (function(){
      if (n < 3) return;
      var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mq && mq.matches) return;
      if (!('IntersectionObserver' in window)) return;
      var FIRST = 6500, STEP = 4000, MAX = 2;
      var done = 0, timer = null, dead = false, io = null;
      var EV = ['pointerdown','touchstart','wheel','keydown','focusin','pointerenter'];
      function stop(){
        if (dead) return;
        dead = true;
        clearTimeout(timer); timer = null;
        if (io){ io.disconnect(); io = null; }
        EV.forEach(function(e){ root.removeEventListener(e, stop); });
      }
      function advance(){
        if (dead || done >= MAX || i >= n - 1){ stop(); return; }
        done++;
        go(i + 1);
        timer = setTimeout(advance, STEP);
      }
      EV.forEach(function(e){ root.addEventListener(e, stop, {passive:true}); });
      document.addEventListener('visibilitychange', function(){ if (document.hidden) stop(); });
      io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting && !timer && !dead) timer = setTimeout(advance, FIRST);
        });
      }, {threshold: 0.6});
      /* v54 speed: the peek is armed by the shopper's first tap/scroll/key anywhere on the page (PageSpeed never
         interacts, and the two automatic slides at 6.5 s and 10.5 s were most of its Speed Index). */
      var ARM = ['pointerdown','touchstart','scroll','wheel','keydown'];
      function arm(){ ARM.forEach(function(e){ window.removeEventListener(e, arm, true); }); if (!dead) io.observe(root); }
      ARM.forEach(function(e){ window.addEventListener(e, arm, {capture:true, passive:true}); });
    })();
  }

  function buy(root){
    if (root.dataset.on) return; root.dataset.on = '1';
    var q = new URLSearchParams(location.search);
    var f0 = F[q.get('formula')] ? q.get('formula') : 'moisture';
    var s0 = SCENT[q.get('scent')] ? q.get('scent') : 'vanilla';
    var t0 = 'one';
    var state = {tier:t0, active:0, open:false, rows:[{f:f0, s:s0, pinned:true}]};
    var tiers = [].slice.call(root.querySelectorAll('[data-tier]'));
    var pick = root.querySelector('[data-fx-pick]');
    var fchips = [].slice.call(pick.querySelectorAll('[data-fx]'));
    var schips = [].slice.call(pick.querySelectorAll('[data-scent]'));
    var madeEl = pick.querySelector('[data-fx-made]');
    var mixBtn = pick.querySelector('[data-fx-mix]');
    var scopeEl = pick.querySelector('[data-fx-scope]');
    var scopeList = pick.querySelector('[data-fx-scopelist]');
    var form = root.querySelector('[data-fx-form]');
    var addBtn = root.querySelector('[data-fx-add]');
    var payBtn = root.querySelector('[data-fx-shoppay]');
    var freeEl = root.querySelector('[data-fx-free]');
    var eachEl = root.querySelector('[data-fx-each]');
    var smellEl = root.querySelector('[data-fx-smell]');
    var HOLDER = root.getAttribute('data-holder');
    var COND = {vanilla:root.getAttribute('data-cond-vanilla'), unscented:root.getAttribute('data-cond-unscented')};
    var bar = document.querySelector('[data-fx-bar]');
    var barP = document.querySelector('[data-fx-barp]');
    var barS = document.querySelector('[data-fx-bars]');

    function tierEl(){ for (var k = 0; k < tiers.length; k++) if (tiers[k].getAttribute('data-tier') === state.tier) return tiers[k]; return tiers[0]; }
    function count(){ return parseInt(tierEl().getAttribute('data-n'), 10); }
    function sync(){
      var n = count();
      while (state.rows.length < n) state.rows.push({f:state.rows[0].f, s:state.rows[0].s, pinned:false});
      if (state.rows.length > n) state.rows.length = n;
      if (state.active >= n) state.active = 0;
      if (n < 2){ state.open = false; state.active = 0; }
    }
    function mixed(){ for (var k = 1; k < state.rows.length; k++) if (state.rows[k].f !== state.rows[0].f) return true; return false; }
    function setF(key){
      var a = state.active, r = state.rows[a]; r.f = key;
      if (a === 0){ r.pinned = true; for (var k = 1; k < state.rows.length; k++) if (!state.rows[k].pinned) state.rows[k].f = key; }
      else r.pinned = true;
      if (a === 0){ var u = new URL(location.href); u.searchParams.set('formula', key); history.replaceState(null, '', u); }
      render();
    }
    function setS(key){
      var a = state.active, r = state.rows[a]; r.s = key;
      if (a === 0){ for (var k = 1; k < state.rows.length; k++) if (!state.rows[k].pinned) state.rows[k].s = key; }
      else r.pinned = true;
      render();
    }

    function ingredients(){
      var f = F[state.rows[0].f], s = state.rows[0].s;
      root.querySelector('[data-fx-alabel]').textContent = 'IN THE ' + f.name.toUpperCase() + ' FORMULA';
      var ul = root.querySelector('[data-fx-actives]'); ul.innerHTML = '';
      f.actives.forEach(function(a){
        var li = document.createElement('li');
        var b = document.createElement('b'); b.textContent = a[0]; li.appendChild(b);
        if (a[1]){ var d = document.createElement('span'); d.setAttribute('aria-hidden','true'); d.textContent = ' · '; li.appendChild(d); li.appendChild(document.createTextNode(a[1])); }
        ul.appendChild(li);
      });
      var ph = f.ph.replace(/\s*–\s*/, ' to ');
      root.querySelector('[data-fx-phtitle]').textContent = 'pH ' + ph;
      phSvg(root.querySelector('[data-fx-phsvg]'), f.ph);
      root.querySelector('[data-fx-liqlabel]').textContent = 'THE SHAMPOO INSIDE · ' + f.name;
      root.querySelector('[data-fx-inci]').textContent = f.inci;
      root.querySelector('[data-fx-shelllabel]').textContent = 'THE SOAP SHELL · ' + SCENT[s];
      root.querySelector('[data-fx-shell]').textContent = SHELL.filter(function(x){ return s !== 'unscented' || x !== 'Parfum'; }).join(', ');
      if (smellEl) smellEl.textContent = s === 'unscented' ? 'nothing added' : 'vanilla milk';
    }

    function render(){
      sync();
      var t = tierEl(), n = count(), ar = state.rows[state.active];
      tiers.forEach(function(x){
        var on = x === t;
        x.classList.toggle('is-on', on);
        var xb = x.querySelector('.sap-pdp-tbtn'); if (xb) xb.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (pick.parentNode !== t) t.appendChild(pick);
      madeEl.textContent = F[ar.f].name.toLowerCase() + ' is made for ' + F[ar.f].made + '.';
      fchips.forEach(function(c){ c.setAttribute('aria-pressed', c.getAttribute('data-fx') === ar.f ? 'true' : 'false'); });
      schips.forEach(function(c){ c.setAttribute('aria-pressed', c.getAttribute('data-scent') === ar.s ? 'true' : 'false'); });
      var isMixed = mixed(), open = state.open || isMixed;
      mixBtn.hidden = !(n > 1 && (open ? !isMixed : true));
      mixBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      mixBtn.innerHTML = open ? 'DONE' : 'MIX &rarr;';
      scopeEl.hidden = !open; scopeList.innerHTML = '';
      if (open){
        for (var k = 0; k < n; k++){
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'sap-label sap-pdp-srow';
          b.setAttribute('aria-pressed', k === state.active ? 'true' : 'false');
          b.innerHTML = '<span>Shampoo ' + (k + 1) + '</span><span>' + F[state.rows[k].f].name + '</span>';
          (function(idx){ b.addEventListener('click', function(){ state.active = idx; render(); }); })(k);
          scopeList.appendChild(b);
        }
      }
      var price = t.getAttribute('data-price');
      label();
      if (eachEl) eachEl.style.display = n > 1 ? '' : 'none';
      if (freeEl) freeEl.textContent = t.getAttribute('data-free') === '1' ? 'free shipping' : 'free shipping on 2+ bottles';
      form.querySelector('[data-fx-variant]').value = V[state.rows[0].f][state.rows[0].s];
      if (barP) barP.textContent = price;
      if (barS) barS.textContent = n + ' × ' + F[state.rows[0].f].name;
      ingredients();
    }

    tiers.forEach(function(t){ var tb = t.querySelector('.sap-pdp-tbtn'); if (tb) tb.addEventListener('click', function(){ state.tier = t.getAttribute('data-tier'); render(); }); });
    fchips.forEach(function(c){ c.addEventListener('click', function(){ setF(c.getAttribute('data-fx')); }); });
    schips.forEach(function(c){ c.addEventListener('click', function(){ setS(c.getAttribute('data-scent')); }); });
    mixBtn.addEventListener('click', function(){
      if (state.open || mixed()){ state.active = 0; state.open = false; } else { state.open = true; }
      render();
    });

    /* v47: the theme buy box (snippets/sapone-kb.liquid, replaces the Kaching widget) owns quantity and the
       bundle payload: it writes the hidden inputs into this form; Kaching's backend applies the discount.
       (Before v47: KACHING BUNDLES wrote its own hidden inputs into this form and intercepted the submit.) So the form posts
       natively and never overrides quantity. The label (2026-10-02, IM8 style) reads the
       selected Kaching bar: "SAVE 20% + FREE SHIPPING", "SAVE 41% + FREE GIFTS". The
       percent is Kaching's own price vs its struck-through price; no bar -> ADD TO CART. */
    function offer(){
      var bar = document.querySelector('.sap-kb-bar.is-sel');
      if (!bar) return 'ADD TO CART';
      function num(sel){ var e = bar.querySelector(sel); return e ? parseFloat(e.textContent.replace(/[^0-9.]/g, '')) : NaN; }
      var now = num('.sap-kb-price'), was = num('.sap-kb-full');
      var pct = (was > now && now > 0) ? Math.round((1 - now / was) * 100) : 0;
      var gifts = [].map.call(bar.querySelectorAll('.sap-kb-gt'), function(e){ return e.textContent; });
      var extra = !gifts.length ? '' : gifts.length > 1 ? 'FREE GIFTS' : /shipping/i.test(gifts[0]) ? 'FREE SHIPPING' : 'FREE GIFT';
      if (!pct) return extra ? 'ADD TO CART + ' + extra : 'ADD TO CART';
      return 'SAVE ' + pct + '%' + (extra ? ' + ' + extra : '');
    }
    function label(){
      var t = offer();
      if ((addBtn.textContent || '').trim() !== t) addBtn.textContent = t;
    }
    if ('MutationObserver' in window) new MutationObserver(label).observe(addBtn, {childList:true, characterData:true, subtree:true});
    document.addEventListener('change', function(e){ if (e.target.closest && e.target.closest('.sap-kb')) setTimeout(label, 0); });
    var kbT = null;
    (function wait(n){
      label();
      var kb = document.querySelector('.sap-kb');
      if (kb && kb.querySelector('.sap-kb-bar.is-sel')){
        if ('MutationObserver' in window) new MutationObserver(function(){ clearTimeout(kbT); kbT = setTimeout(label, 30); })
          .observe(kb, {subtree:true, attributes:true, attributeFilter:['class'], childList:true});
        return;
      }
      if (n < 40) setTimeout(function(){ wait(n + 1); }, 250);
    })(0);
    var ret = form.querySelector('[data-fx-return]');
    if (payBtn) payBtn.addEventListener('click', function(){
      ret.value = '/checkout';
      if (form.requestSubmit) form.requestSubmit(addBtn); else form.submit();
      setTimeout(function(){ ret.value = ''; }, 1500);
    });
    function commit_unused(dest, btn){
      var t = tierEl(), conds = parseInt(t.getAttribute('data-cond'), 10), holder = t.getAttribute('data-holder') === '1', n = count();
      var qty = {}, order = [];
      for (var k = 0; k < n; k++){ var id = V[state.rows[k].f][state.rows[k].s]; if (qty[id] === undefined){ qty[id] = 0; order.push(id); } qty[id]++; }
      var items = order.map(function(id){ return {id:id, quantity:qty[id]}; });
      if (conds > 0) items.push({id:COND[state.rows[0].s], quantity:conds});
      if (holder) items.push({id:HOLDER, quantity:1});
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:items})})
        .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function(){ location.href = dest; })
        .catch(function(){ if (btn) btn.disabled = false; form.submit(); });
    }

    /* mini review rotator: three real reviews from the stories section */
    var mini = root.querySelector('[data-fx-mini]');
    if (mini){
      var quotes = [].slice.call(mini.querySelectorAll('.sap-pdp-mq')), mi = 0, timer = null;
      function show(i){
        mi = (i + quotes.length) % quotes.length;
        quotes.forEach(function(q, k){ q.classList.toggle('is-on', k === mi); });
      }
      function auto(){ clearInterval(timer); timer = setInterval(function(){ show(mi + 1); }, 6000); }
      mini.querySelector('[data-fx-mnext]').addEventListener('click', function(){ show(mi + 1); auto(); });
      mini.querySelector('[data-fx-mprev]').addEventListener('click', function(){ show(mi - 1); auto(); });
      if (!window.matchMedia('(prefers-reduced-motion:reduce)').matches) auto();
    }

    /* accordion */
    function accSet(acc, open){
      acc.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.getElementById(acc.getAttribute('aria-controls')).hidden = !open;
      acc.querySelector('[data-acc-sign]').innerHTML = open ? '&minus;' : '+';
    }
    [].forEach.call(root.querySelectorAll('[data-acc]'), function(acc){
      acc.addEventListener('click', function(){ accSet(acc, acc.getAttribute('aria-expanded') !== 'true'); });
    });
    /* links to #ingredients (header WHAT'S INSIDE) open that row */
    function accHash(){
      var row = location.hash && root.querySelector('.sap-pdp-acc' + location.hash.replace(/[^#\w-]/g, ''));
      if (row) accSet(row.querySelector('[data-acc]'), true);
    }
    accHash(); window.addEventListener('hashchange', accHash);
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href*="#ingredients"]');
      if (a) { var b = root.querySelector('#ingredients [data-acc]'); if (b) accSet(b, true); }
    }, true);

    /* sticky bar: shows once the CTA block has scrolled off the top */
    var cta = root.querySelector('[data-fx-cta]');
    if (bar && cta && 'IntersectionObserver' in window){
      new IntersectionObserver(function(e){
        bar.hidden = !(!e[0].isIntersecting && e[0].boundingClientRect.top < 0);
        /* Not body padding: that left a band below the footer. The footer reads this. */
        document.documentElement.style.setProperty('--sap-bar-h', bar.hidden ? '0px' : bar.offsetHeight + 'px');
      }, {threshold:0}).observe(cta);
      var bb = document.querySelector('[data-fx-barbtn]');
      if (bb) bb.addEventListener('click', function(e){
        e.preventDefault();
        window.scrollTo({top: root.getBoundingClientRect().top + window.scrollY - 112, behavior:'smooth'});
      });
    }

    render();
  }

  function scan(){
    document.querySelectorAll('[data-sap-gal]').forEach(gallery);
    document.querySelectorAll('[data-sap-pdp]').forEach(buy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
